
  function buildRaynerSizeGuides() {
    document.querySelectorAll('.product__description table').forEach((table) => {
      if (table.closest('.rmr-guide')) return;
      const rows = Array.from(table.rows);
      if (rows.length < 2) return;
      const headers = Array.from(rows[0].cells).map((cell) => cell.textContent.trim());
      if (headers.length < 2) return;
      const measures = rows.slice(1).map((row) => Array.from(row.cells).map((cell) => cell.textContent.trim()));
      if (!measures.some((row) => /width|length|chest|tolerance/i.test(row[0]))) return;
      if (measures.some((row) => row.length !== headers.length)) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'rmr-guide';
      table.before(wrapper);
      const original = document.createElement('div');
      original.className = 'rmr-guide__original';
      wrapper.append(original);
      original.append(table);
      const cards = document.createElement('div');
      cards.className = 'rmr-guide__cards';
      const help = document.createElement('p');
      help.textContent = document.querySelector('.rmr-guide-config')?.dataset.help || '';
      cards.append(help);
      headers.slice(1).forEach((size, index) => {
        const details = document.createElement('details');
        if (index === 0) details.open = true;
        const summary = document.createElement('summary');
        summary.textContent = size;
        const list = document.createElement('dl');
        measures.forEach((row) => {
          const pair = document.createElement('div');
          const label = document.createElement('dt');
          label.textContent = row[0];
          const value = document.createElement('dd');
          value.textContent = row[index + 1];
          pair.append(label, value);
          list.append(pair);
        });
        details.append(summary, list);
        cards.append(details);
      });
      wrapper.append(cards);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', buildRaynerSizeGuides);
  else buildRaynerSizeGuides();
  document.addEventListener('shopify:section:load', buildRaynerSizeGuides);
